import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthCallback } from "@/components/AuthCallback";
import { ChatWidget } from "@/components/ChatWidget";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { CartDrawer } from "@/components/CartDrawer";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import AuthPage from "@/pages/AuthPage";
import Orders from "@/pages/Orders";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Admin from "@/pages/Admin";
import Profile from "@/pages/Profile";
import Wishlist from "@/pages/Wishlist";
import PolicyPage from "@/pages/PolicyPage";
import Contact from "@/pages/Contact";

function Guard({ children, admin }) {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-[60vh] grid place-items-center font-mono text-xs text-neutral-500">LOADING...</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (admin && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
}

function AppRoutes() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/shop" element={<Shop />} />
      <Route path="/product/:id" element={<ProductDetail />} />
      <Route path="/login" element={<AuthPage mode="login" />} />
      <Route path="/register" element={<AuthPage mode="register" />} />
      <Route path="/orders" element={<Guard><Orders /></Guard>} />
      <Route path="/profile" element={<Guard><Profile /></Guard>} />
      <Route path="/wishlist" element={<Guard><Wishlist /></Guard>} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
      <Route path="/admin" element={<Guard admin><Admin /></Guard>} />
      <Route path="/shipping-policy" element={<PolicyPage slug="shipping-policy" />} />
      <Route path="/returns" element={<PolicyPage slug="returns" />} />
      <Route path="/privacy" element={<PolicyPage slug="privacy" />} />
      <Route path="/terms" element={<PolicyPage slug="terms" />} />
      <Route path="/contact" element={<Contact />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <CartProvider>
          <div className="grain min-h-screen flex flex-col bg-[#09090B]">
            <Navbar />
            <main className="flex-1">
              <AppRoutes />
            </main>
            <Footer />
            <CartDrawer />
            <ChatWidget />
            <Toaster theme="dark" position="bottom-right" />
          </div>
        </CartProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
